import React, { useState, useRef, useEffect } from 'react';
import { makeStyles,withStyles } from '@material-ui/core/styles';
import {Button,Slider,Tooltip,Typography,Divider,Dialog}from '@material-ui/core';
import AvatarEditor from 'react-avatar-editor';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import edit from '../../assets/images/patientsFilter.png';
import {StatusCodes} from 'http-status-codes';
const useStyles = makeStyles(theme => ({
    bigAvatar: {
		width: 110,
		height: 110,
		borderRadius: 0
	},
    hidden: {
        display: "none"
    },
    defaultImage: {
        padding: 60,
        width: "100%",
         //backgroundColor:"white",
         backgroundColor: "rgba(199, 225, 241, 0.1)",
        cursor: "pointer"
    },
    posRel: {
        position: "relative"
    },
    editPen: {
        cursor: "pointer",
        width: 35
    },
    EditButton: {
        position: "absolute",
        bottom: '5%',
        right: '28%',
        minWidth: 0,
        [theme.breakpoints.down('sm')]: {
            right: '38%',
        }
    },
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing(2),
        width: "600px",
        [theme.breakpoints.down('sm')]: {
            width: "100%"
        }
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[StatusCodes.INTERNAL_SERVER_ERROR],
    },
    primaryBtn: {
        color: "white",
        backgroundColor: "#2262bf",
        textTransform: "capitalize",
        border: "1px solid " +  "#2262bf",
        borderRadius: "50px",
        textAlign: "right",
        padding: "4px 15px",
        marginLeft: "7px",
        '&:hover': {
            backgroundColor:  "#2262bf",
            color:"white",
            border: "1px solid " +  "#2262bf",
        }
    },
    thirdBtn: {
        color:"white",
        //float:"right",
        backgroundColor:  "#2262bf",
        border: "1px solid " +  "#2262bf",
        borderRadius: "25px",
        marginLeft: "4rem",
        padding: "6px 30px",
        fontWeight: "400",
        lineHeight: "1.42857143",
        '&:hover': {
            color: "white",
            backgroundColor:  "#2262bf",
            border: "1px solid " +   "#2262bf"
        }
    },
    gridPadding:{
        [theme.breakpoints.down('sm')]: {
            padding: 0
        }
    },
    createUser: {
        minWidth: "142px !important", textTransform: "uppercase", backgroundColor: "rgba(75, 123, 227, 1)", color: '#fff',
        borderRadius: "25px", border: "1px solid ",marginLeft: "16px", fontWeight: "500 !important",
        '&:hover': { color: '#1d5d90',  border: "1px solid " },
        [theme.breakpoints.down("sm")]: {
            width: "120%",
            marginLeft:"-15px"
        }
    },
    cancelBtn: { width: "142px", height: "36px", textTransform: "uppercase", backgroundColor: "rgba(255, 255, 255, 1)",
    color: "rgba(75, 123, 227, 1)", borderRadius: "25px", border: "1px solid rgba(0, 0, 0, 0.12)", marginLeft: 25, fontWeight: "500 !important",
    '&:hover': { color: '#1d5d90',  border: "1px solid " },
    [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginLeft:0
    }},
}));

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
export default function (props) {
    const classes = useStyles();
    const [img, setimg] = useState();
    const [rotate, setrotate] = useState(0);
    const [scale, setscale] = useState(0.5);
    const [imageSelected, setImage] = useState(true);
    const [imageErr, setErr] = useState(false);
    const { onClose, open, onCloseDialog} = props;
   const [errorText,setErrorText]=useState(true);
    let currentEditor = useRef();
    let inputRef = useRef();
let imagesize=2097152,ninty=90,pointfive=.5;
    useEffect(() => {
        (props.open && imageSelected) && setimg(props.defaultsrc);
    });
    const handleBrowseImage = () => {
        inputRef.current.click();
    };
    const changeHandler = async (e) => {
        let file = e.target.files[0];
        const SUPPORTED_FORMATS = [
            "image/jpg","image/jpeg"];
        if (file) {
            if (SUPPORTED_FORMATS.includes(file.type)&&file.size<imagesize) {
                setimg(file);
                setImage(false);
                setErr(false);
            } else {
                setErr(true);
                setimg(edit);
                if(!(SUPPORTED_FORMATS.includes(file.type))){
                setErrorText("Unsupported Format");
                }
                if(file.size>imagesize){
                setErrorText("File Size is greater than 2MB");
                }
            }
            } else {
                file.base64Rep = img;
                props.form.setFieldValue(props.field.name, file);
                setErr(true);
                setimg(edit);
                if(!(SUPPORTED_FORMATS.includes(file.type))){
                setErrorText("Unsupported Format");
                }
                if(file.size>imagesize){
                 setErrorText("File Size is greater than 2MB");
                }
        }
    };
    let image;
    const handleSave = () => {
        if (currentEditor && !imageSelected) {
            image = {
                file: img,
                base64Rep: currentEditor.current.getImageScaledToCanvas().toDataURL()
            };
            setrotate(0);
            setscale(pointfive);
            setimg(props.defaultsrc);
            setImage(true);
        }
        if(imageErr){
            setErr(true);
        }else{
        imageSelected ? onCloseDialog() : onClose(image);
        }
    };
    const handleCloseDialogBox = () => {
        setErrorText();
        setrotate(0);
        setscale(pointfive);
        setimg(props.defaultsrc);
        setImage(true);
        onCloseDialog();
    };
    const rotateLeft = () => {
        setrotate(rotate - ninty);
    };
    const rotateRight = () => {
        setrotate(rotate + ninty);
    };

    const ZoomComponent = (props) => {
        const { children, open1, value } = props;
        const popperRef = React.useRef(null);
        React.useEffect(() => {
            if (popperRef.current) {
                popperRef.current.update();
                setscale(value);
            }
        });
        return (
            <Tooltip
                PopperProps={{
                    popperRef,
                }}
                open={open1}
                enterTouchDelay={0}
                placement="top"
                title={value}
            >
                {children}
            </Tooltip>
        );
    };

    return (
        <>
            <Dialog aria-labelledby="simple-dialog-title" open={open}>
                <MuiDialogTitle id="customized-dialog-title" className={classes.root}>
                    Choose Image
                </MuiDialogTitle>
                <DialogContent style={{ paddingTop: "20px", paddingBottom: "20px", fontSize: "14px", color:"white" }}>
                    <GridContainer >
                    <GridItem md={5} lg={5} sm={12} xs={12} >
                    <AvatarEditor image={img ? img : edit} ref={currentEditor}
                    className={imageSelected ? classes.defaultImage : undefined} width={210} height={210} border={0} rotate={rotate}  scale={parseFloat(scale)} />
                                <Typography variant="caption" color="error">
                                    {imageErr && <p>{errorText}</p>}
                                </Typography>
                        </GridItem>
                        <GridItem md={7} lg={7} sm={12} xs={12} className={classes.gridPadding}>
                            <input type="file" ref={inputRef} className={classes.hidden} onChange={changeHandler}
                            accept="image/jpeg,image/jpg,image/png"/>
                            <br />
                            <Button onClick={handleBrowseImage} className={classes.thirdBtn}>Browse Image</Button>
                            <br /><br /><br/>
                            <b style={{color:"#2262bf"}}>ROTATE:</b> <span><Button onClick={rotateLeft} className={classes.primaryBtn} >{"LEFT"}</Button>
                            <Button className={classes.primaryBtn} onClick={rotateRight}>{"RIGHT"}</Button></span><br /><br />
                            <b style={{color:"#2262bf"}}>ZOOM:</b> <Slider
                                ValueLabelComponent={ZoomComponent}
                                aria-label="custom thumb label"
                                defaultValue={pointfive}
                                max={4}
                                min={pointfive}
                                step={0.1}
                            />
                        </GridItem>
                    </GridContainer>
                </DialogContent>
                <Divider/>
                <DialogActions>
                    <Button onClick={handleSave} className={classes.createUser} >{"SAVE"}</Button>
                    <Button className={classes.cancelBtn} onClick={handleCloseDialogBox}>{"CLOSE"}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
